import React, {useContext} from 'react';
import './ModalNewUser.css'
import {Context} from "../../index";
import {createChatAndMsg} from "../../http/ChatAPI";

const ModalTaskToMessage = ({showTaskToMsg, setShowTaskToMsg, allUsers, setExecutor, executor, id}) => {

    const {userStore} = useContext(Context)

    const newChatMessage = (firstSocketId, secondSocketId, message) => {
        createChatAndMsg(firstSocketId, secondSocketId, message)
        setShowTaskToMsg(false)
    }

    return (
        <div className={showTaskToMsg ? "modal active" : "modal"} onClick={() => setShowTaskToMsg(false)}>
            <div className={showTaskToMsg ? "modal__content active" : "modal__content"} onClick={e => e.stopPropagation()}>

                <h4>Выберите пользователя для отправки задачи</h4>
                <div className="task__to__msg__block">
                    <select onChange={e => setExecutor(e.target.value)} value={executor}
                            className="select__css select__css__chat">
                        <option>Выбор...</option>
                        {allUsers.filter(item => item.id !== userStore.user.id)
                            .map(users =>
                                <option
                                    onClick={() => setExecutor(users)}
                                    key={users.id}
                                    value={users.socketId}
                                >
                                    {users.firstName} {users.secondName}
                                </option>
                            )}
                    </select>
                    {!executor || executor === "Выбор..."
                        ?
                        null
                        : <div>
                            <button
                                className='btn__task__to__msg'
                                onClick={() => newChatMessage(userStore.user.socketId, executor, `task/${id}`)}
                            >
                                Отправить
                            </button>
                        </div>

                    }

                </div>

                <div className="cl__add__chat__block">
                    <div className="cl-btn-6" onClick={() => setShowTaskToMsg(false)}>
                        <div className="cl-btn-6-in">
                            <div className="cl-btn-6-txt">Закрыть</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ModalTaskToMessage;